<template>
  <div class="line-campaign-message" :style="styles" v-if="campaignMessage.length > 0"><span class="mess" v-html="campaignMessage"></span><span class="bg"></span></div>
</template>

<script>
export default {
  name: 'LineCampaignMessage',
  props: {
    targetInfo: {
      type: Object,
      default(){
        return null
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
  },
  computed: {
    campaignMessage(){
      if(!!this.targetInfo) {
        return `今ならなんと、LINE登録で<br>${this.targetInfo.name}の占いが１つ無料に！`
      } else {
        return ''
      }
    },
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--mess-bg': this.colorScheme.messBg,
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_mess_bg: var(--mess-bg);

.line-campaign-message {
  background: $l_col_mess_bg;
  width: 100%;
  max-width: 580px;
  margin: 0 auto;
  text-align: center;
  padding: 0;
  color: $l_col_keycolor;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  .mess {
    display: inline-block;
    position: relative;
    z-index: 10;
    &::after,
    &::before {
      content: "";
      position: absolute;
      bottom: 5px;
      top: 0;
      display: inline-block;
      border-left: 2px solid $l_col_keycolor;
      width: 0;
      margin: auto;
    }
    &::before {
      transform: rotate(-20deg);
      left: -20px;
      transform-origin: right bottom;
    }
    &::after {
      transform: rotate(20deg);
      right: -15px;
      transform-origin: left bottom;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/partials/LineCampaignMessage.vue